module.exports = __webpack_public_path__ + "static/media/analysis-reportnew loanx3.1e302f93.svg";